// Chapter 1: Insurance Fundamentals for Crop
// Main file - imports all sections and quiz questions

import { ch1Section1, ch1Section2 } from './ch1-sections-1-2';
import { ch1Section3, ch1Section4 } from './ch1-sections-3-4';
import { ch1Section5, ch1Section6 } from './ch1-sections-5-6';
import { ch1Quiz1 } from './ch1-quiz-1';
import { ch1Quiz2 } from './ch1-quiz-2';

const chapter1 = {
  id: 1,
  title: "Insurance Fundamentals for Crop",
  sections: [
    ch1Section1,
    ch1Section2,
    ch1Section3,
    ch1Section4,
    ch1Section5,
    ch1Section6
  ],
  quizQuestions: [...ch1Quiz1, ...ch1Quiz2]
};

export default chapter1;
